import React, { useState } from 'react';
import { View, Text } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import MaskedInputDefault from '../../components/Form/MaskedInputDefault';

import styles from './styles';

const PhonePix = () => {
    const [numberPhone, setNumberPhone] = useState('');
    return (
        <>
            <HeaderDefault title={"Celular"} />

            <View style={styles.container}>
                <View style={styles.contentPhone}>
                    <MaskedInputDefault
                        mask="(99) 99999-9999"
                        keyboardType="numeric"
                        value={numberPhone}
                        onValueChange={(value) => setNumberPhone(value)}
                        placeholder={"Número do celular"}
                    />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor da transferência:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>XX,XXX.XXGPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do dia:</Text>
                    <Text>GPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONTINUAR"} titlePage={"Confirmar tranferência"} />
        </>
    );
}

export default PhonePix;